// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gNUm","name":"styles_name__3QhOo","phone":"styles_phone__3ivcL"};